import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.svg'
import { useFetch } from '../../hooks/useFetch';
import { fetchTerms } from '../../api/api';
import { useTranslation } from 'react-i18next';


const Terms = () => {
    const { data, isLoading, error } = useFetch(["terms"], fetchTerms);
    const { t } = useTranslation();
    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={t('pageTitles.termsOfUse')} pagesub={t('pageTitles.termsOfUse')} />
            {isLoading ? <>Loading...</> : error ? <>Error</> : (
                <div className=' section-padding'>
                    <div className="container">
                        <div dangerouslySetInnerHTML={{ __html: data?.data?.termsOfUse }} />
                    </div>
                </div>
            )}

            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default Terms;

